// src/App.js
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/Home/Homepage";
import ArchivePage from "./pages/Archive/ArchivePage";
import CategoriesPage from "./pages/CategoriesPage/CategoriesPage";
import AboutPage from "./pages/About/AboutPage";
import AuthPage from "./pages/Auth/AuthPage";
import CreatePostPage from "./pages/WritePost/CreatePostPage";
import EditPostPage from "./pages/EditPost/EditPostPage";
import PostDetailPage from "./pages/PostDetail/PostDetailPage";
import NotFound from "./pages/NotFound/NotFound";
const App = () => {
  const [, forceUpdate] = useState({});

  useEffect(() => {
    // 监听用户资料更新事件
    const handleProfileUpdate = () => {
      // 强制重新渲染整个应用
      forceUpdate({});
    };

    window.addEventListener("userProfileUpdated", handleProfileUpdate);

    // 清理事件监听器
    return () => {
      window.removeEventListener("userProfileUpdated", handleProfileUpdate);
    };
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/categories" element={<CategoriesPage />} />
        <Route path="/archive" element={<ArchivePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/posts/create" element={<CreatePostPage />} />
        <Route path="/posts/:id/edit" element={<EditPostPage />} />
        <Route path="/posts/:id" element={<PostDetailPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default App;
